import { useEffect, useState } from 'react';
import { closeNotification } from '../../Constants/AppData'
import { connect } from 'react-redux'

import isElectron from 'is-electron'

let electron;

if ( isElectron() ) {
    electron = window.require( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that handles alert events.
 */

const AlertEventHandler = () => {
    const [ alertQueue, setAlertQueue ] = useState( null );
    const [ activeAlert, setActiveAlert ] = useState( null );

    useEffect( () => {        
        if ( isElectron() ) {
            ipcRenderer.on( "alertChannel", handleAlert );
            ipcRenderer.on( "resetAlertQueue", resetAlertQueue );
        }
        return () => {
            if(isElectron()){
                ipcRenderer.off( "alertChannel", handleAlert );
                ipcRenderer.off( "resetAlertQueue", resetAlertQueue );
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );


    const handleAlert = ( event, alerts ) => {
        // console.info( "alertChannel", alerts );
        //Retrieve the actual alert queue. and the length of the queue
        let queue = alertQueue || [];
        let queueLength = queue.length;

        ////Search and remap actions (for the moment we only have one) in order to map the methods.
        alerts.map( alert => {
            alert.actions.map( action => {
                if ( action.method === closeNotification ) {
                    action.method = () => setActiveAlert( activeAlert + 1 )
                }
                return null;
            } );
            //Push alert to the alert queue
            queue.push( alert );
            return null;
        } );
        //Set the new alertQueue
        setAlertQueue(queue);
        setActiveAlert(queueLength);
    }

    //Set the alertQueue and the activeAlert to null
    const resetAlertQueue = () => {
        setAlertQueue(null);
        setActiveAlert(null);
    }

    return null
}

const mapStateToProps = ( state ) => (
    {
        isNetworkAvailable: state.sensors.isNetworkAvailable,
    });

export default connect( mapStateToProps, {} )( AlertEventHandler );